import {
  type PostingReadinessResult,
  platformDisplayName,
} from '../../../shared/posting-readiness';

const UNSUPPORTED_PUBLISH_PLATFORMS: ReadonlySet<string> = new Set(['slack', 'x', 'twitter']);

export function isUnsupportedPublishPlatform(platform: string): boolean {
  return UNSUPPORTED_PUBLISH_PLATFORMS.has(platform.toLowerCase());
}

export function withUnsupportedPublishBlock(
  result: PostingReadinessResult,
): PostingReadinessResult {
  if (!isUnsupportedPublishPlatform(String(result.platform))) return result;
  const blocking = {
    code: 'platform_not_supported',
    message: `Mora can't publish to ${platformDisplayName(result.platform)} yet.`,
    severity: 'blocked' as const,
    dimension: 'connection' as const,
  };
  return {
    ...result,
    state: 'blocked',
    canPublish: false,
    issues: [blocking],
    blockingIssues: [blocking],
    warningIssues: [],
    primaryAction: null,
  };
}
